export default __webpack_public_path__ + "static/media/math-girl-icon.819ce24c.png";